module.exports = __webpack_public_path__ + "img/case_icon2.fbbc0c63.png";